import { useEffect, useState } from 'react'
import heic2any from 'heic2any'

export const useGetImageBlob = (
  { file }: { file: File | null },
  setIsLoading: (isLoading: boolean) => void
) => {
  const [imageBlob, setImageBlob] = useState<Blob | null>(null)

  useEffect(() => {
    if (!file) {
      setImageBlob(null)
      setIsLoading(false)
      return
    }

    if (file.type === 'image/heic') {
      setIsLoading(true)
      heic2any({ blob: file, toType: 'image/jpeg', quality: 0.7 })
        .then((result) => {
          const blob = Array.isArray(result) ? result[0] : result
          setImageBlob(blob)
        })
        .catch(() => setImageBlob(null))
        .finally(() => setIsLoading(false))
    } else {
      setImageBlob(file)
      setIsLoading(false)
    }
  }, [file, setIsLoading])

  return { imageBlob }
}
